import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@nxt-costco-com/forge-components';
import type { AnalyticsAccordionProps } from './types';
import { AppActionTypes } from 'src/types.ts';
import { AccordionFormEntry } from 'src/components/CookieSettings/AccordionFormEntry';

export const AnalyticsAccordion: FC<AnalyticsAccordionProps> = ({ dispatch, state }: AnalyticsAccordionProps) => {
    const { t } = useTranslation('translation');

    return (
        <AccordionFormEntry
            title={t('accordians.analytics.name')}
            isOptedIn={state.optInAnalytics}
            setOptIn={(value) =>
                dispatch({
                    payload: value,
                    type: AppActionTypes.SET_OPT_IN_PERSONALIZED_ANALYTICS,
                })
            }
            categoryKey="analytics"
        >
            <Text variant='b2'>{t('accordians.analytics.description')}</Text>
        </AccordionFormEntry>
    );
};
